import React from "react";

interface TableColProps {
  children: React.ReactNode;
  className?: string;
  width?: string;
  isHeader?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const TableCol: React.FC<TableColProps> = ({ 
  children, 
  className = "", 
  width = "w-auto",
  isHeader = false,
  onClick
}) => {
  const baseClasses = "px-2 md:px-4 py-1 text-left";
  const cellClasses = isHeader ? baseClasses : "px-2 md:px-4 py-2";
  
  return (
    <td className={`${width} ${cellClasses} ${className}`} onClick={onClick}>
      {children}
    </td>
  );
}; 